<ng-container *ngFor="let field of card?.fields">
  <div class="bl-display--flex bl-margin-bottom--8" [attr.data-automation-id]="field.config?.automationId">
    <span class="bl-font-weight--800 bl-margin-right--8">{{ field.label }}</span>
    <span>{{ resolveDisplayValue(field) }}</span>
  </div>
</ng-container>
